import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { dismissiblePaths, NavigationPath } from "@/constants/navigation";

const useDismissiblePath = () => {
  const pathname = useLocation().pathname;
  const [isDismissible, setDismissible] = useState<boolean>(false);
  useEffect(() => {
    if (pathname) {
      if (pathname === NavigationPath.Home) {
        setDismissible(false);
      } else {
        dismissiblePaths.every((dismissiblePath: string) => {
          if (pathname.includes(dismissiblePath)) {
            setDismissible(true);
            return false;
          }
          return true;
        });
      }
    }
  }, [pathname]);

  return isDismissible;
};

export default useDismissiblePath;
